<script setup lang="ts">
import { useLongScroll } from '@libs/utils';

interface HotelSelectionMobileLayoutProps {
  hasFixedHeight?: boolean;
}
const props = defineProps<HotelSelectionMobileLayoutProps>();

interface HotelSelectionMobileLayoutEmits {
  (eventName: 'long-scroll'): void;
}
const emit = defineEmits<HotelSelectionMobileLayoutEmits>();

const { longScrollEvent } = useLongScroll();

longScrollEvent.subscribe(() => emit('long-scroll'));
</script>

<template>
  <div
    :class="[
      'hotel-selection-mobile-layout',
      { 'fixed-height': !!props.hasFixedHeight },
    ]"
  >
    <div class="header">
      <slot name="header" />
    </div>

    <div class="content">
      <slot name="content" />
    </div>

    <div class="list-map-switch">
      <slot name="list-map-switch" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-mobile-layout {
  position: relative;

  display: flex;
  flex-direction: column;

  min-height: 100vh;
  min-height: 100dvh;

  background-color: var(--color-white);

  &.fixed-height {
    height: 100vh;
    height: 100dvh;
  }

  .header {
    display: contents;
    position: relative;
    z-index: 2;
  }

  .content {
    flex-grow: 1;
    position: relative;
    z-index: 1;
  }

  .list-map-switch {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: var(--spacing-24);
    z-index: 2;
  }
}
</style>

<style lang="scss">
.hotel-selection-mobile-layout {
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
}
</style>
